import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  swiperButtonType: "按钮类型",
  buttonTop: "按钮上边距",
  buttonLeft: "按钮左边距",
  showButton: "显示按钮",
  buttonIconClassName: "按钮样式",
  effect: "切换效果",
  updateTimer: "数据轮询时间",
  restDataUrl: "外接数据源地址",
  buttonIconSize: "按钮大小",
  buttonIconColor: "按钮颜色",
  buttonIconShowBackGround: "按钮显示背景色",
  buttonIconBackgroundColor: "按钮背景色",
  buttonIconBackgroundWidth: "按钮背景色宽度",
  buttonIconBackgroundHeight: "按钮背景色高度",
  buttonIconBackGroundBorderRadius: "按钮背景色圆角",
  buttonIconCustomTop: "自定义按钮位置",
  buttonIconPadding: "按钮内边距",
  buttonIconTop: "按钮上边距",
  direction: "切换方向",
  speed: "切换速度",
  loop: "循环切换",
  autoplay: "自动播放",
  "fadeEffect.crossFade": "左右切换淡出效果",
  "cubeEffect.slideShadows": "方块切换开启阴影",
  "cubeEffect.shadow": "方块切换开启投影",
  "cubeEffect.shadowOffset": "方块切换投影距离",
  "cubeEffect.shadowScale": "方块切换投影缩放比例",
  "coverflowEffect.rotate": "3d流切换Y轴的旋转角度",
  "coverflowEffect.stretch": "3d流切换拉伸值",
  "coverflowEffect.depth": "3d流切换深度",
  "coverflowEffect.modifier": "3d流切换倍率",
  "coverflowEffect.slideShadows": "3d流切换阴影",
  "flipEffect.slideShadows": "3d翻转切换阴影",
  "flipEffect.limitRotation": "3d翻转切换限制旋转",
  paginationPosition: "分页器位置",
  bulletsSize: "圆点边距",
  bulletsMargin: "圆点大小",
  rotate: "旋转角度",
  progressbarBackground: "进度条默认颜色",
  "pagination,type": "分类器类型",
  "pagination,clickable": "分页器点击切换",
  "pagination,bulletsPrimaryColor": "圆点分页器默认颜色",
  "pagination,bulletsActiveColor": "圆点分页器选中颜色"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
